import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { useSnackbar } from "react-simple-snackbar";
import {
  LearnerForgotPassword,
  VerifyOtp,
  Setpassword,
  ResendOtp
} from "../../redux/actions/AuthAction";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import {
  parsePhoneNumber,
  getCountryCallingCode,
  isValidPhoneNumber,
} from "react-phone-number-input";


const ForgotPasswordForm = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));

  const [number, setNumber] = useState("");
  const [internationalNumber, setInternationalNumber] = useState("");
  const [callingCode, setCallingCode] = useState("");

  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [loder, setLoder] = useState(false);
  const [apicall, setApicall] = useState("forgotpass");
  const [resendOTP, setResendOTP] = useState(false);

  const user = JSON.parse(localStorage.getItem("DATA"));

  useEffect(() => {
    if (internationalNumber) {
      const userPhoneNumber = parsePhoneNumber(internationalNumber);

      if (userPhoneNumber) {
          const country_calling_code = getCountryCallingCode(
            userPhoneNumber.country
          );
          setCallingCode("+" + country_calling_code);
          setNumber(
            internationalNumber.replace("+" + country_calling_code, "")
          );
      }
    }
  }, [internationalNumber]);

  const forgotPassword = (e) => {
    e.preventDefault();
   if( isValidPhoneNumber(internationalNumber)){
    setLoder(true);
    const data = {
      phoneNumber: number,
      countryCode: callingCode
    };
    const onSuccess = (msg) => {
      console.log(msg);
      openSnackbar(msg);
      setApicall("varifyotp");
      setLoder(false);
    };
    const onError = (msg) => {
      console.log(msg);
      openSnackbar(msg);
      setLoder(false);
    };
    dispatch(LearnerForgotPassword(data, onSuccess, onError));
  }else{
    openSnackbar("Invalid Mobile Number");
  }
  };

  const varifyOTP = (e) => {
    e.preventDefault();
    setLoder(true);
    const data = {
      OTP: otp,
    };
    const onSuccess = (msg) => {
      console.log(msg);
      setLoder(false);
      openSnackbar(msg);
      setApicall("updatepass");
    };
    const onError = (msg) => {
      setLoder(false);
      console.log(msg);
      openSnackbar(msg);
    };
    dispatch(VerifyOtp(data, onSuccess, onError));
  };
  const updatePassword = (e) => {
    e.preventDefault();
    setLoder(true);
    const data = {
      phoneNumber_: number,
      password_: password,
    };

    const onSuccess = (msg) => {
      console.log(msg);
      openSnackbar(msg);
      setLoder(false);
      localStorage.setItem("LOGIN", JSON.stringify("true"));
      localStorage.setItem("ROLE", JSON.stringify("Learner"));
      localStorage.setItem("USER", JSON.stringify(user));
      localStorage.setItem("TOKEN", JSON.stringify(user.token));
      localStorage.setItem("IS_LOGOUT", true);
      localStorage.removeItem("DATA");

      history.push("/dashboard");
      window.location.reload();
      history.push("/dashboard");
    };
    const onError = (msg) => {
      console.log(msg);
      setLoder(false);
      openSnackbar(msg);
    };

    dispatch(Setpassword(data, onSuccess, onError));
  };

  //resend otp
    //RESEND OTP COUNTER
    useEffect(() => {
      if (resendOTP) {
        var timeLeft = 40;
        var elem = document.getElementById("some_div");
        var timerId = setInterval(countdown, 1000);
  
        function countdown() {
          if (timeLeft === -1) {
            clearTimeout(timerId);
            setResendOTP(false);
          } else {
            elem.innerHTML = `Resend OTP (${timeLeft})`;
            timeLeft--;
          }
        }
      }
    }, [resendOTP]);
  
    const resendOtp = () =>{
      // ResendOtp
      if(number){
      const data = {
        phoneNumber:number
      }
      const onSuccess = () =>{
        openSnackbar("OTP send Successfully")
      }
   
      const onError = (msg) =>{
        openSnackbar(msg)
      }
      dispatch(ResendOtp(data,onSuccess,onError))
    }else{
      openSnackbar("Please Enter Phone number or Email")
    }
    }

  return (
    <form
      className="text-center"
      onSubmit={
        apicall === "forgotpass"
          ? (e) => forgotPassword(e)
          : apicall === "varifyotp"
          ? (e) => varifyOTP(e)
          : apicall === "updatepass"
          ? (e) => updatePassword(e)
          : ""
      }
    >
      <div className="modal-body">
        <h1 className="text-left ml-md-5">Reset Password 🔑</h1>
        <div class="form-group">

          {/* <input
            className="input mt-3"
            placeholder="Mobile Number"
            type="number"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            required
          /> */}

<PhoneInput
                id="passresetfield"
                placeholder="Enter Mobile number"
                className="input mt-3 ml-md-5"
                international
                countryCallingCodeEditable={true}
                defaultCountry={time_zone.country}
                // country={time_zone.country}
                value={internationalNumber}
                onChange={setInternationalNumber}
                // disabled={disabledNumber}
              />

          {apicall === "varifyotp" ? (
            <>
            <input
              className="input mt-3"
              placeholder="6-digit OTP"
              type="number"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />
            {resendOTP ? (
              <p
                className="text-danger mr-5"
                id="some_div"
                style={{ textAlign:"right" }}
              ></p>
            ) : (
              <p
                style={{ textAlign:"right", cursor: "pointer" }}
                onClick={() => {
                  setResendOTP(true)
                  resendOtp()
                }
                }
                className="mr-5"
              >
                Resend OTP ?
              </p>
            )}
            </>
          ) : apicall === "updatepass" ? (
            <input
              id="newresetpass"
              className="input mt-3"
              placeholder="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          ) : (
            ""
          )}

          <button
            type="submit"
            disabled={loder ? true : false}
            className={loder ? "continueBTNdisabled" : "continueBTN"}
          >
            {loder ? "Loading ..." : "Continue"}
          </button>
        </div>
        {/* <p className="line">or</p> */}
      </div>
    </form>
  );
};

export default ForgotPasswordForm;
